interface DocumentData {
  id?: number;
  path?: string;
  fullPath?: string;
  name?: string;
  originalName?: string;
  mimeType?: string;
  size?: number;
  athleteId?: number;
  organizationId?: number;
  createDate?: string;
  createrId?: number;
  updateDate?: string;
  updaterId?: number;

  rights?: string[];
}


export class Document {
  public static readonly NUM_ITEMS: number = 10;

  public static getNonTranslatableFields(): string[] { return ['id', 'path', 'fullPath', 'name', 'originalName', 'mimeType', 'size', 'athleteId', 'organizationId', 'createDate', 'createrId', 'updateDate', 'updaterId']; }
  public static getTranslatableFields(): string[] { return []; }
  public static getFields(): string[] { return ['id', 'path', 'fullPath', 'name', 'originalName', 'mimeType', 'size', 'athleteId', 'organizationId', 'createDate', 'createrId', 'updateDate', 'updaterId']; }
  public static getKeyFields(): string[] { return ['id']; }

  public static fromAPI(data: DocumentData): Document {
    return new Document({
      id: data.id,
      path: data.path,
      fullPath: data.fullPath,
      name: data.name,
      originalName: data.originalName,
      mimeType: data.mimeType,
      size: data.size,
      athleteId: data.athleteId,
      organizationId: data.organizationId,
      createDate: data.createDate,
      createrId: data.createrId,
      updateDate: data.updateDate,
      updaterId: data.updaterId,

      rights: data.rights,
    });
  }

  public static fromAPIList(data: DocumentData[]): Document[] {
    return data.map((item: DocumentData) => Document.fromAPI(item));
  }

  id?: number;
  path?: string;
  fullPath?: string;
  name?: string;
  originalName?: string;
  mimeType?: string;
  size?: number;
  athleteId?: number;
  organizationId?: number;
  createDate?: string;
  createrId?: number;
  updateDate?: string;
  updaterId?: number;

  rights?: string[];


  constructor({id, path, fullPath, name, originalName, mimeType, size, athleteId, organizationId, createDate, createrId, updateDate, updaterId, rights}:DocumentData) {
    this.id = id;
    this.path = path;
    this.fullPath = fullPath;
    this.name = name;
    this.originalName = originalName;
    this.mimeType = mimeType;
    this.size = size;
    this.athleteId = athleteId;
    this.organizationId = organizationId;
    this.createDate = createDate;
    this.createrId = createrId;
    this.updateDate = updateDate;
    this.updaterId = updaterId;

    this.rights = rights;
  }



  public toJson(): DocumentData {
    return {
      id: this.id,
      path: this.path,
      fullPath: this.fullPath,
      name: this.name,
      originalName: this.originalName,
      mimeType: this.mimeType,
      size: this.size,
      athleteId: this.athleteId,
      organizationId: this.organizationId,
      createDate: this.createDate,
      createrId: this.createrId,
      updateDate: this.updateDate,
      updaterId: this.updaterId
    }
  }
}
